import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.helpers.handleTemplateSubmitterErrors', {
    emailSubmitterRequiredError: 'Email submitter needs to be set.',
    regularSubmitterRequiredError: 'Submitter needs to be set.',
    externalSubmitterRequiredError: 'External submitter needs to be set.',
    dextSubmitterRequiredError: 'Dext submitter needs to be set.',
    reqularOrExternalSubmitterRequiredError: 'At least one submitter needs to be set.',
});
